/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState, useEffect, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  get_mux_interview_video_upload_playback_id_candidate_action,
  get_mux_interview_video_upload_url_candidate_action,
} from "../../../redux/_actions/candidate";
import {
  submit_assessment_kit_action,
  get_assigned_assessment_kit_details_data_action,
} from "../../../redux/_actions";
import * as UpChunk from "@mux/upchunk";
import { useParams, useNavigate } from "react-router-dom";
import { user_meta_data_action } from "../../../redux/_actions/common/auth.actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import {
  get_assessment_next_question_action,
  save_assessment_question_response_action,
} from "../../../redux/_actions";
import useCheckFullScreenMode from "../../../_hooks/useCheckFullScreenMode";
import useDisableChange from "../../../_hooks/useDisableChange";
import { appRoutes } from "../../../_routes/app-routes";
import useDisableActions from "../../../_hooks/useDisableActions";
const constraints = {
  audio: {
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
  },
  video: true,
  echoCancellation: true,
};

function useTakeAssessment(props) {
  const [question, setQuestion] = useState({});
  const [remainingCount, setRemainingCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [permissionAllowed, setPermissionAllowed] = useState(false);
  const [startVideoQuestion, setStartVideoQuestion] = useState(false);
  const [intervalId, setIntervalId] = useState();
  const [videoUpload, setVideoUpload] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [videoUploadMessage, setVideoUploadMessage] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const [confirmProgressModalOpen, setConfirmProgressModalOpen] =
    useState(false);
  const [nextEnabled, setNextEnabled] = useState(false);
  const [assessmentCompleted, setAssessmentCompleted] = useState(false);
  const [submitAssessmentMessage, setSubmitAssessmentMessage] = useState("");
  const [isErrorOccurred, setIsErrorOccurred] = useState(false);
  const [assignAssessmentDetails, setAssignAssessmentDetails] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const videoElement = useRef();
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const saveButtonRef = useRef();

  const { nextQuestionData } = useSelector(
    (state) => state.get_assessment_next_question_reducer
  );

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { candidateAssignedAssessmentData } = useSelector(
    (state) => state.get_assigned_assessment_kit_details_data_reducer
  );

  const { handleFullScreenChange, setFullScreen, fullScreenModalOpen } =
    useCheckFullScreenMode(props);
  const { handleVisibilityChange } = useDisableChange(props);
  const { disableActions } = useDisableActions();


  useEffect(() => {
    handleFullScreenChange();
    handleVisibilityChange();
    setFullScreen(true);
    disableActions();
  }, []);

  useEffect(() => {
    resetData();
    const id = params?.assignedAssessmentId;
    if (id) {
      getAssessmentDetails(id);
    }
  }, []);

  useEffect(() => {
    if (candidateAssignedAssessmentData) {
      setAssignAssessmentDetails(candidateAssignedAssessmentData);
    }
  }, [candidateAssignedAssessmentData]);
  useEffect(() => {
    callCameraOn();
    return function cleanup() {
      stopCamera();
    };
  }, [permissionAllowed]);

  useEffect(() => {
    if (permissionAllowed) {
      const id = params?.assignedAssessmentId;
      if (videoUpload === false && id) {
        callApi(id);
      }
    }
  }, [permissionAllowed, videoUpload, params]);

  useEffect(() => {
    if (nextQuestionData?.data) {
      setStartVideoQuestion(true);
      setQuestion(nextQuestionData?.data);
      setAssessmentCompleted(false);
    }
    if (nextQuestionData?.remaining_count) {
      setRemainingCount(nextQuestionData?.remaining_count);
    }
    if (nextQuestionData?.remaining_count === 0) {
      const id = params?.assignedAssessmentId;
      if (id) {
        getAssessmentDetails(id);
      }
    }
    if (nextQuestionData?.remaining_count === 0 && nextQuestionData?.status) {
      setErrorMessage(nextQuestionData?.status);
    }
  }, [nextQuestionData]);

  useLayoutEffect(() => {
    if (startVideoQuestion) {
      startRecording();
    }
  }, [startVideoQuestion]);

  useEffect(() => {
    if (startVideoQuestion) {
      setIntervalId(
        setInterval(() => {
          setTimer((no) => no + 1);
        }, 1000)
      );
    }
    return clearInterval(intervalId);
  }, [startVideoQuestion]);

  useEffect(() => {
    if (question?.id) {
      if (
        timer >
        (question?.question_id &&
          question.question_id?.time_to_answer_in_minutes) *
          60
      ) {
        setTimer(
          (question?.question_id &&
            question.question_id?.time_to_answer_in_minutes) * 60
        );
        saveButtonRef?.current && saveButtonRef.current?.click();

        return clearInterval(intervalId);
      }
    }
  }, [timer]);

  const getAssessmentDetails = async (id) => {
    await dispatch(get_assigned_assessment_kit_details_data_action(id));
  };

  const callCameraOn = () => {
    if ("MediaRecorder" in window) {
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          setPermissionAllowed(true);
        })
        .catch((e) => {
          setPermissionAllowed(false);
          alert(e?.message);
        });
    } else {
      setPermissionAllowed(false);
      alert("Video recording is not supported in your browser.");
    }
  };

  const stopCamera = () =>
    videoElement.current &&
    videoElement.current.srcObject &&
    videoElement.current.srcObject.getTracks().forEach((t) => t.stop());

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(user_meta_data_action());
    const res = await dispatch(get_assessment_next_question_action(id));
    if (res.message) {
      setIsErrorOccurred(true);
    }
    setLoading(false);
  };

  const uploadVideoToMux = async (uploadUrl, blobUrl) => {
    const imageResponse = await fetch(blobUrl);
    let data = await imageResponse.blob();
    let metadata = {
      type: "video/webm",
    };
    if (data) {
      let uploadFile = new File([data], "test.webm", metadata);
      try {
        const upload = UpChunk.createUpload({
          endpoint: uploadUrl.data.url,
          file: uploadFile,
          chunkSize: 5120,
        });
        // Subscribe to events
        upload.on("error", (error) => {
          showWarningMessage("Can not upload video.");
        });

        upload.on("progress", (progress) => {
          setUploadProgress(progress.detail);
          setVideoUploadMessage("Video Upload in progress please wait.");
        });

        upload.on("success", () => {
          setVideoUploadMessage("Video Uploaded. Click next to continue.");
          // call api for /interview/candidate-interview-video/
          onVideoUpload(uploadUrl.data.id);
        });
      } catch (error) {
        showWarningMessage("Error uploading video.");
      }
    }
  };

  const startRecording = () => {
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        const options = {
          mimeType: "video/webm",
        };
        const recordedChunks = [];
        const mediaRecorder = new MediaRecorder(stream, options);
        try {
          videoElement.current.srcObject = stream;
        } catch {
          window.location.reload();
        }

        mediaRecorder.addEventListener("dataavailable", function (e) {
          if (e.data.size > 0) recordedChunks.push(e.data);
        });

        mediaRecorder.addEventListener("stop", function () {
          stream.getTracks().forEach((track) => track.stop());
          uploadVideo(URL.createObjectURL(new Blob(recordedChunks)));
        });

        if (saveButtonRef && saveButtonRef.current) {
          saveButtonRef?.current?.addEventListener(
            "click",
            function onStopClick() {
              mediaRecorder.stop();
              this.removeEventListener("click", onStopClick);
              videoElement.current.srcObject = null;
            }
          );
        }

        mediaRecorder.start();
      })
      .catch((e) => {
        alert(
          "Error with recording. Please check your camera and microphone.",
          e
        );
      });
  };

  const uploadVideo = async (blobUrl) => {
    setNextEnabled(false);
    setUploadProgress(0);
    setVideoUpload(true);
    setStartVideoQuestion(false);
    setConfirmProgressModalOpen(true);

    let res = await dispatch(
      get_mux_interview_video_upload_url_candidate_action()
    );
    uploadVideoToMux(res?.data, blobUrl);
  };

  const onVideoUpload = async (id) => {
    let res = await dispatch(
      get_mux_interview_video_upload_playback_id_candidate_action(id)
    );
    let data = res?.data;
    if (data) {
      if (userMetaData) {
        let assetIdsData = {
          video_asset_id: data?.playback_ids && data.playback_ids[0].id,
          video_playback_id: data?.asset_id,
        };
        await dispatch(
          save_assessment_question_response_action(question?.id, assetIdsData)
        );
      }
    }

    setNextEnabled(true);
  };

  const onSubmitAssessmentClick = () => {
    if (nextQuestionData?.remaining_count !== 0) {
      setSubmitAssessmentMessage(
        "There are few questions still left to answer. Do you want to submit?"
      );
      setConfirmModalOpen(true);
    } else {
      onConfirmSubmitAssessmentClick();
    }
  };

  const onNextClick = () => {
    setTimer(0);
    setVideoUpload(false);
    setUploadProgress(0);
  };

  const onConfirmSubmitAssessmentClick = async () => {
    const id = params?.assignedAssessmentId;
    if (id) {
      const res = await dispatch(submit_assessment_kit_action(id));
      if (res?.id) {
        setAssessmentCompleted(true);
        setSubmitAssessmentMessage("");
        stopCamera();
        setConfirmModalOpen(false);
        onExitFullScreenClick();
        getAssessmentDetails(res?.id);
        setVideoUpload(false);
      }
    }
  };

  const onCloseConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const onFullScreenClick = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };
  const onExitFullScreenClick = () => {
    if (!fullScreenModalOpen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const onBacktoAssessementsClick = () => {
    navigate(appRoutes.assessementKit.candidateAssignedAssessments);
    stopCamera();
    onExitFullScreenClick();
  };
  const resetData = () => {
    setErrorMessage(null);
    setRemainingCount(null);
    setStartVideoQuestion(false);
    setQuestion({});
    setAssessmentCompleted(false);
  };
  return {
    videoElement,
    saveButtonRef,
    loading,
    question,
    timer,
    videoUpload,
    uploadProgress,
    videoUploadMessage,
    confirmModalOpen,
    confirmProgressModalOpen,
    nextEnabled,
    assessmentCompleted,
    submitAssessmentMessage,
    remainingCount,
    fullScreenModalOpen,
    confirmModalOpen,
    submitAssessmentMessage,
    isErrorOccurred,
    assignAssessmentDetails,
    errorMessage,
    onNextClick,
    onSubmitAssessmentClick,
    onConfirmSubmitAssessmentClick,
    onCloseConfirmModal,
    onFullScreenClick,
    onBacktoAssessementsClick,
  };
}

export default useTakeAssessment;
